const WeatherAndImages = {
  'Extreme Winters': {
    Image: 'cold.png',
  },
  'Mild Winters': {
    Image: 'wind.png',
  },
  'Hot + Dry': {
    Image: 'desert.png',
  },
  'Hot + Humid': {
    Image: 'sweat.png',
  },
  Rainy: {
    Image: 'rain.png',
  },
  'Cool and Pleasant': {
    Image: 'happy.png',
  },
}

export default WeatherAndImages
